import BaseProxy from "../../base-proxy";
const TARGET_URL = "/v2/workflow/api/company";

/**
 * @class getProccessesListProxy
 * @description Class used for getting proccesses list API.
 * @author Aldrev Ven Dayrit
 * @version 1.0
 * @since June 26,2019
 */
export default {
  /**
   * @async
   * @function putCompanyWorkflow
   * @param input - Input parameter instance.
   * @param {String} input.authToken - Token used for issuing authenticated request.
   * @param {String} input.companyId - company ID
   * @param {String} input.processId - proccess ID of workflow
   * @param {Object} input.data - payload of input

   */
  async putCompanyWorkflow(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    const companyId = input.companyId;
    const processId = input.processId;
    const data = {
      data: input.data,
    };
    let endpointUrl = `${backendUrl}${TARGET_URL}/${companyId}/processes/${processId}`;

    return await baseProxy.putAuthenticatedData(endpointUrl, input.authToken, data);
  },
};
